import { PagedList } from "../../../core/models/responses/paged-list";
import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { BasePagingRequest } from "src/app/core/models/requests/base-paging-request";

@Component({
  selector: "app-pagination",
  templateUrl: "./pagination.component.html",
  styleUrls: ["./pagination.component.scss"],
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() pageInfo: PagedList<any>;
  @Input() pageRequest: BasePagingRequest<any>;
  @Input() displayViewChange: boolean = false;
  @Output() requestEvent: EventEmitter<any> = new EventEmitter();
  @Output() exportEvent: EventEmitter<any> = new EventEmitter();
  @Output() changeViewEvent: EventEmitter<any> = new EventEmitter();
  @Input() blurOn: boolean = false;
  @Input() exportable: boolean = false;

  showAsGrid: boolean = false;
  buttonValues: any[] = [];
  nrOfPagesToDisplay = 10;
  itemPerPageIsChanged: boolean = false;
  pageChangeTimer: any;
  constructor() {}

  ngOnInit(): void {
    this.showAsGrid = localStorage.getItem("showAsGrid") === "true";
    this.setShowButtons();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.pageInfo) {
      if (!changes.pageInfo.firstChange) {
        if (changes.pageInfo.previousValue.PageSize != changes.pageInfo.currentValue.PageSize
          || changes.pageInfo.previousValue.PageCount != changes.pageInfo.currentValue.PageCount) {
          this.pageInfo = changes.pageInfo.currentValue;
          this.setShowButtons();
        }
        this.pageInfo = changes.pageInfo.currentValue;
      }
    }
  }
  setShowButtons() {
    this.buttonValues = [];
    if (this.pageInfo.PageCount >= 1) {
      for (let i = 1; i <= this.pageInfo.PageCount; i++) {
        let showButton = true;
        if(showButton){
          this.buttonValues.push(i);
        }
      }
    }
    if (this.itemPerPageIsChanged) {
      this.pageRequest.pageIndex = 1;
      this.itemPerPageIsChanged = false;
    }
  }
  changeView(showAsGrid: boolean) {
    this.showAsGrid = showAsGrid;
    this.changeViewEvent.emit({ event:event, showAsGrid: showAsGrid });
    localStorage.setItem('showAsGrid', JSON.stringify(showAsGrid));
  }
  sendNewPageRequest() {
    if (this.itemPerPageIsChanged){
      const pageIndexIsLower = this.pageRequest.pageIndex > this.pageInfo.TotalItemCount / this.pageRequest.itemPerPage
      pageIndexIsLower ? this.pageRequest.pageIndex = 1 : this.pageRequest.pageIndex 
    }
      
    this.requestEvent.emit(this.pageRequest);
    
  }
  export(){
    this.exportEvent.emit(this.pageRequest);
  }

  nextPage() {
    this.pageRequest.pageIndex += 1;
    this.sendNewPageRequest();
  }

  previousPage() {
    if (this.pageRequest.pageIndex > 1) {
      this.pageRequest.pageIndex -= 1;
      this.sendNewPageRequest();
    }
  }

  firstPage() {
    this.pageRequest.pageIndex = 1;
    this.sendNewPageRequest();
  }
  handlePageIndexChanged(){
      if (this.pageRequest.pageIndex < 1){
        this.pageRequest.pageIndex = 1;
      }
      else if (this.pageRequest.pageIndex > this.pageInfo.PageCount){
        this.pageRequest.pageIndex = this.pageInfo.PageCount;
      }
  }
  lastPage() {
    if (this.buttonValues.length > 0) {
      const lastIndex: number = this.buttonValues[this.buttonValues.length - 1];
      this.pageRequest.pageIndex = lastIndex;
      this.sendNewPageRequest();
    }
  }

  getByNumber(value: number) {
    this.pageChangeTimer = setTimeout(() => {
      this.pageRequest.pageIndex = value;
      this.sendNewPageRequest();
    }, 1000);
    
  }

  setItemPerPage(){
    this.itemPerPageIsChanged = true;
    this.sendNewPageRequest()
  }
  onPageInputChange(value: any) {
  // Boşsa hiçbir şey yapma (kullanıcı daha yazıyor olabilir)
  if (value === null || value === undefined || value === '') {
    return;
  }

  const page = Number(value);

  // Sayı değilse çık
  if (Number.isNaN(page)) {
    return;
  }

  // min-max clamp
  const max = this.pageInfo?.PageCount ?? 1;
  const clamped = Math.max(1, Math.min(max, page));

  // UI'ı da düzelt (kullanıcı 999999 yazarsa geri oturt)
  this.pageRequest.pageIndex = clamped;

  // Eğer backend 0-based istiyorsa burada dönüştür:
  // this.getByNumber(clamped - 1);
  this.getByNumber(clamped);
}


}
